import { FaExclamationTriangle } from "react-icons/fa";
import "./FraudTicker.css";

const COMPANY_NAME = import.meta.env.VITE_COMPANY_NAME;
const REPAY_NOW_URL = `${import.meta.env.VITE_WEBSITE_LINK}/repay-now`;

const TickerMessage = ({ hidden }: { hidden?: boolean }) => (
  <div className="fraud-ticker__item" aria-hidden={hidden}>
    <FaExclamationTriangle />
    <span className="fraud-ticker__label">Beware of frauds:</span>
    <span>
      Always use our secure{" "}
      <a
        href={REPAY_NOW_URL}
        target="_blank"
        rel="noopener noreferrer"
        className="fraud-ticker__link"
        tabIndex={hidden ? -1 : undefined}
      >
        Repayment on Website Link
      </a>{" "}
      for loan payments. Do not make direct bank payments to fake UPI links or
      unauthorised payment links. {COMPANY_NAME} is not responsible for
      payments made to other accounts.
    </span>
  </div>
);

const FraudTicker = () => {
  return (
    <>
      {/* reserves space so the fixed strip never covers the footer */}
      <div className="fraud-ticker-spacer" />
      <div className="fraud-ticker" role="marquee" aria-label="Fraud alert">
        <div className="fraud-ticker__track">
          <TickerMessage />
          <TickerMessage hidden />
        </div>
      </div>
    </>
  );
};

export default FraudTicker;
